module.exports = __webpack_public_path__ + "static/media/fsc4.d30a12ac.svg";